import React, { FC, useCallback } from 'react';

import Button from '../../../../../../../components/Button';
import {
  useTeeSheetCreatorDispatch,
  useTeeSheetCreatorState
} from '../../../Context/TeeSheetCreator.context';

interface IProps {
  onSelectSlot: () => void;
}

const EmptySlot: FC<IProps> = (props: IProps) => {
  const { onSelectSlot } = props;

  const { selectedGroup } = useTeeSheetCreatorState();

  const {
    actions: { onSelectSeat }
  } = useTeeSheetCreatorDispatch();

  const onCancel = useCallback(onSelectSeat(0)(0), [onSelectSeat]);

  return (
    <div className="empty-slot">
      <Button variant="contained" color="primary" className="action-button" onClick={onSelectSlot}>
        ADD PLAYER
      </Button>

      {!!selectedGroup && (
        <Button variant="outlined" color="primary" className="action-button" onClick={onCancel}>
          CANCEL
        </Button>
      )}
    </div>
  );
};

export default EmptySlot;
